import React, { useState, useEffect } from 'react';
import { roots } from 'components/utils/helpers';
import classnames from 'classnames';

// Icons
import Close from 'svg/close';
import Arrow from 'svg/arrow';
import Metronome from 'svg/metronome';

/**
 * Hints
 *
 * Show hints to the user
 */
const Controls = (props) => {
  const paredDownRoots = ['G', 'C', 'D', 'A', 'A♭', 'F'];
  const close = props.closeAction;
  const [ppmNum, setPpmNum] = useState(0);
  const [root, setRoot] = useState(0);

  const increasePpm = () => {
    const newPpm = Math.min(ppmNum + 1, 180);
    props.controller.setBpm(newPpm);
    setPpmNum(newPpm);
  }

  const decreasePpm = () => {
    const newPpm = Math.max(ppmNum - 1, 60);
    props.controller.setBpm(newPpm);
    setPpmNum(newPpm);
  }

  useEffect(() => {
    setPpmNum(props.controller.getBpm());
    setRoot(paredDownRoots.indexOf(roots[props.controller.getRoot()]));
    // eslint-disable-next-line
  }, []);

  return (
    <article className='Main-overlay Controls'>
      {/*Actions to control the Controls*/}
      <button
        title='Close'
        className='button button--outline button__close'
        onClick={close}
      >
        <Close className='Controls__icon Controls__icon-close' title='Close' />
      </button>
      <section className='Main-overlay__inner'>
        <div className='Controls__section Controls__ppm'>
          <div className='Controls__ppm-buttons'>
            <button title='Increase PUFFS Per Minute' className='Controls__ppm-button' onClick={increasePpm}>
              <Arrow title='Increase PUFFS Per Minute' />
            </button>
            <button title='Decrease PUFFS Per Minute' className='Controls__ppm-button' onClick={decreasePpm}>
              <Arrow title='Decrease PUFFS Per Minute' />
            </button>
          </div>
          <div className='Controls__ppm-info'>
            <h3 className='Controls__ppm-rate digital'>{ppmNum}</h3>
            <div className='Controls__ppm-description'>
              <Metronome title='PUFFS Per Minute Rate' />
              <h5 className='Controls__ppm-name digital'>PPM</h5>
            </div>
          </div>
        </div>
        <div className='Controls__section Controls__keys'>
          <h3 className='Controls__keys-title title'>Keys</h3>
          <ul className='Controls__keys-list'>
            {paredDownRoots.map((key, index) => {
              return (
                <li className='Controls__keys-list-item' key={index}>
                  <button
                    className={classnames('Controls__keys-list-button digital', {
                      active: index === root
                    })}
                    onClick={() => {
                      setRoot(index);
                      props.controller.setRoot(roots.indexOf(key));
                    }}
                  >{key}</button>
                </li>
              )
            })}
          </ul>
        </div>
      </section>
    </article>
  );
};

export default Controls;

